import { useSyncExternalStore } from 'react';

function subscribe(notify: () => void) {
  const observer = new MutationObserver(notify);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-sidebar-drawer-open'],
  });
  return () => observer.disconnect();
}

// Dialogs are portalled outside the launcher, so CSS hiding alone cannot suspend them.
export function useSupportSidebarOpen() {
  return useSyncExternalStore(
    subscribe,
    () => !!document.querySelector('[data-sidebar-drawer-open="true"]'),
    () => false
  );
}

// The layout owns toolbar space; the assistant owns its launcher and session.
export function useSupportLauncherSlot() {
  return useSyncExternalStore(
    subscribe,
    () => document.querySelector('[data-support-launcher-slot]'),
    () => null
  );
}
